module.exports = __webpack_public_path__ + "static/media/BZ.77454546.png";